import { useState, useCallback } from 'react'
import axios from 'axios'
import { API_BASE_URL } from '../config/api'
import { useAsyncQuery } from './useAsyncQuery'

export const usePhotoCarousel = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const fetchAllPhotos = useCallback(async () => {
    const response = await axios.get(`${API_BASE_URL}/api/events/my-events?limit=100`, {
      withCredentials: true
    })

    const allPhotos = []
    ;(response.data.events || []).forEach(event => {
      if (event.media && event.media.length > 0) {
        event.media.forEach(media => {
          if (media.mimetype?.startsWith('image/')) {
            allPhotos.push({
              ...media,
              eventName: event.name,
              eventId: event._id
            })
          }
        })
      }
    })

    return allPhotos.sort((a, b) => new Date(b.uploadDate) - new Date(a.uploadDate))
  }, [])

  const { data: photos, loading, error, refetch: fetchPhotos } = useAsyncQuery(
    fetchAllPhotos,
    [],
    { initialData: [] }
  )

  const openModal = (photo) => {
    setSelectedPhoto(photo)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedPhoto(null)
  }

  const handlePhotoClick = (photo, isDragging) => {
    if (!isDragging) {
      openModal(photo)
    }
  }

  // Get unique photos (removing duplicates based on filename)
  const uniquePhotos = (photos || []).reduce((acc, photo) => {
    if (!acc.find(p => p.filename === photo.filename)) {
      acc.push(photo)
    }
    return acc
  }, [])

  return {
    photos,
    uniquePhotos,
    loading,
    error,
    selectedPhoto,
    isModalOpen,
    handlePhotoClick,
    openModal,
    closeModal,
    fetchPhotos
  }
}
